/* ───────────── Журнал изменений: подписи полей словами (ДС-11) ─────────────
 *
 * Поле записи в журнале показывается по-русски: сначала по словарю, у ссылки на другую запись — названием той записи
 * (его даёт сервер по внешнему ключу), иначе название собирается из частей имени поля: «answered_at» — «Ответ
 * (время)», «plan_start» — «Начало (план)». Неизвестная часть остаётся как есть — лучше точный код, чем выдумка.
 */

/** Подписи полей: общие для карточки «История изменений» и журнала */
export const JOURNAL_FIELD_TITLES: Record<string, string> = {
  accepted_at: 'Принято',
  accepted_quantity: 'Принятое количество',
  accepted_revision: 'Принятая ревизия',
  accepted_user_id: 'Принял',
  acknowledged_at: 'Подтверждено',
  act_number: 'Номер акта',
  action: 'Действие',
  active: 'Действует',
  activity_id: 'Работа графика',
  actual_date: 'Дата по факту',
  actual_end: 'Окончание по факту',
  actual_finish: 'Факт окончания',
  actual_quantity: 'Количество по факту',
  actual_start: 'Факт начала',
  address: 'Адрес',
  advance_guarantee: 'Гарантия возврата аванса',
  amendment_id: 'Допсоглашение',
  amount: 'Сумма',
  amount_net: 'Сумма без НДС',
  amount_total: 'Сумма с НДС',
  answer: 'Ответ',
  answer_type: 'Вид ответа',
  answered_at: 'Ответ дан',
  approved: 'Утверждено',
  approved_at: 'Утверждено',
  approved_by: 'Утвердил',
  approver_id: 'Согласующий',
  archived_at: 'В архиве с',
  article: 'Статья',
  as_of: 'На дату',
  assignee: 'Исполнитель',
  assignee_id: 'Исполнитель',
  assignments: 'Роли в приглашении',
  at: 'Время',
  attempts: 'Попыток',
  author_id: 'Автор',
  avg_price: 'Средняя цена',
  bank: 'Банк',
  base_price: 'Базовая цена',
  basis: 'Основание платежа',
  batch: 'Партия',
  before: 'Условия до',
  bik: 'БИК',
  bin: 'БИН',
  body: 'Текст',
  budget_line_id: 'Строка бюджета',
  buyer: 'Снабженец',
  buyer_id: 'Снабженец',
  cancel_reason: 'Причина отмены',
  cancelled_at: 'Отменено',
  card_confirmed_at: 'Карточка подтверждена',
  card_confirmed_by: 'Подтвердил карточку',
  categories: 'Категории',
  category: 'Категория',
  cert_number: 'Номер сертификата',
  change_no: 'Номер изменения',
  channel: 'Канал',
  checked_at: 'Проверено',
  checklist: 'Чек-лист',
  close_note: 'Примечание при закрытии',
  closed_at: 'Закрыто',
  closed_by: 'Закрыл',
  code: 'Код',
  code_1c: 'Код в 1С',
  color: 'Цвет',
  comment: 'Комментарий',
  completed_at: 'Выполнено',
  condition: 'Условие',
  config: 'Настройки',
  confirmed_at: 'Подтверждено',
  constraint_date: 'Дата ограничения',
  constraint_type: 'Ограничение',
  consumer: 'Получатель',
  contract_amount: 'Сумма договора',
  contract_date: 'Дата договора',
  contract_id: 'Договор',
  contract_kind: 'Вид договора',
  contract_number: 'Номер договора',
  contract_value: 'Стоимость договора с заказчиком',
  cost: 'Стоимость',
  cost_article: 'Статья ФП',
  cost_kind: 'Вид затрат',
  counted_qty: 'Насчитано',
  counterparty_bin: 'БИН контрагента',
  counterparty_id: 'Контрагент',
  counterparty_name: 'Контрагент',
  crew: 'Бригада',
  critical: 'Критическая',
  curator_by: 'Куратор',
  currency: 'Валюта',
  customer_id: 'Заказчик',
  data_date: 'Дата данных',
  date: 'Дата',
  date_from: 'Дата с',
  date_to: 'Дата по',
  day: 'День',
  days: 'Дней',
  deadline: 'Срок',
  decided_at: 'Решение принято',
  decided_by: 'Решил',
  decision: 'Решение',
  decision_note: 'Пояснение к решению',
  decline_reason: 'Причина отказа',
  delivery_address: 'Адрес доставки',
  delivery_cost: 'Стоимость доставки',
  delivery_days: 'Срок поставки, дней',
  delta: 'Разница',
  department: 'Подразделение',
  description: 'Описание',
  details: 'Подробности',
  device: 'Устройство',
  diff_qty: 'Расхождение',
  direction: 'Направление',
  direction_id: 'Направление',
  director_name: 'Руководитель',
  distance_km: 'Расстояние, км',
  doc_date: 'Дата документа',
  docs: 'Документы',
  document: 'Документ',
  documents_ok: 'Документы проверены',
  done: 'Выполнено',
  done_at: 'Выполнено',
  done_by: 'Выполнил',
  due_at: 'Срок',
  due_date: 'Срок',
  due_on: 'Срок',
  duration_days: 'Длительность, дней',
  duration_min: 'Длительность, мин',
  effective_from: 'Действует с',
  email: 'Почта',
  enabled: 'Включено',
  end_date: 'Окончание',
  ends_at: 'Окончание',
  ends_on: 'Окончание',
  engine_hours: 'Моточасы',
  entity: 'Запись',
  entity_id: 'Запись',
  entity_type: 'Вид записи',
  equipment: 'Оборудование',
  error: 'Ошибка',
  estimate_amount: 'Сумма по смете',
  estimate_id: 'Смета',
  estimate_price: 'Сметная цена',
  estimate_value: 'Сметная стоимость',
  event_type: 'Вид события',
  exception_reason: 'Причина исключения',
  expected_qty: 'Ожидалось',
  expires_at: 'Действует до',
  expires_on: 'Действует до',
  exported_at: 'Выгружено',
  external_number: 'Внешний номер',
  external_profile: 'Профиль внешнего участника',
  external_ref: 'Внешняя ссылка',
  file_id: 'Файл',
  finish: 'Окончание',
  finish_date: 'Окончание',
  finished_at: 'Завершено',
  fm_by: 'Финансовый менеджер',
  format: 'Формат',
  from_date: 'Была дата',
  from_status: 'Статус до',
  fuel_litres: 'Топливо, л',
  full_name: 'ФИО',
  funding_source: 'Источник денег',
  grade: 'Класс',
  hired_on: 'Принят на работу',
  hold_decided_at: 'Остановка снята',
  hold_decided_by: 'Снял остановку',
  hold_decision: 'Решение финансового менеджера',
  hold_kind: 'Остановка',
  hold_reason: 'Причина остановки',
  hour_meter: 'Моточасы',
  hours: 'Часы',
  idle_hours: 'Простой, ч',
  idle_reason: 'Причина простоя',
  iik: 'ИИК',
  initiator: 'Инициатор',
  initiator_id: 'Инициатор',
  instructions: 'Указания',
  inventory_number: 'Инвентарный номер',
  invited_by: 'Пригласил',
  invoice_date: 'Дата счёта',
  invoice_number: 'Номер счёта',
  is_active: 'Активно',
  is_carrier: 'Перевозчик',
  is_contractor: 'Подрядчик',
  is_current: 'Действующая',
  is_customer: 'Заказчик',
  is_designer: 'Проектировщик',
  is_distributor: 'Дистрибьютор',
  is_manufacturer: 'Производитель',
  is_owner: 'Владелец компании',
  is_primary: 'Основной',
  is_selected: 'Выбрано',
  is_supplier: 'Поставщик',
  is_system: 'Системная',
  issue: 'Проблема',
  issued_at: 'Выдано',
  issued_on: 'Выдано',
  issuer: 'Кто выдал',
  item_id: 'Позиция каталога',
  item_type: 'Вид позиции',
  items_count: 'Позиций',
  key: 'Ключ',
  kind: 'Вид',
  label: 'Подпись',
  labor_hours: 'Трудозатраты, чел.-ч',
  labor_note: 'Примечание по трудозатратам',
  last_error: 'Последняя ошибка',
  lat: 'Широта',
  legal_entity_id: 'Юрлицо',
  legal_form: 'Форма',
  letter_date: 'Дата письма',
  level: 'Уровень',
  limit_note: 'Примечание к лимиту',
  limit_reason: 'Причина превышения лимита',
  limit_status: 'Лимит',
  lines: 'Строки',
  link_path: 'Ссылка',
  link_type: 'Вид связи',
  list_date: 'Дата списка',
  litres: 'Литры',
  local_code: 'Местный код',
  locale: 'Язык',
  location: 'Место',
  location_from: 'Откуда',
  location_to: 'Куда',
  locked_at: 'Заблокировано',
  lon: 'Долгота',
  machines: 'Машины и механизмы',
  machinist_pay: 'Оплата машиниста',
  manager_user_id: 'Руководитель проекта',
  mark: 'Марка',
  marks: 'Отметки',
  mass: 'Масса',
  materials: 'Материалы',
  max_value: 'Наибольшее значение',
  measure: 'Мера',
  measures: 'Меры',
  membership_id: 'Сотрудник',
  message: 'Сообщение',
  method: 'Способ',
  mime_type: 'Тип файла',
  min_stock: 'Неснижаемый остаток',
  min_value: 'Наименьшее значение',
  mode: 'Режим',
  model: 'Модель',
  model_name: 'Модель',
  money_level: 'Уровень денег',
  month: 'Месяц',
  months: 'Месяцы',
  name: 'Наименование',
  name_kk: 'Название на казахском',
  need_by: 'Нужно к',
  new_amount: 'Новая сумма',
  new_cost_article: 'Новая статья ФП',
  new_end_date: 'Новое окончание',
  new_items: 'Новая спецификация',
  new_payment_terms: 'Новый порядок оплаты',
  new_schedule: 'Новые графики',
  no_three_offers_reason: 'Обоснование закупки без 3 КП',
  norm: 'Норма',
  norm_ref: 'Ссылка на норму',
  note: 'Примечание',
  notes: 'Примечания',
  number: 'Номер',
  number_1c: 'Номер в 1С',
  object_id: 'Объект',
  object_name: 'Объект',
  occurred_at: 'Когда произошло',
  odometer: 'Пробег',
  offer_id: 'КП',
  old_amount: 'Сумма до',
  old_end_date: 'Окончание до',
  old_payment_terms: 'Порядок оплаты до',
  on_hand: 'В наличии',
  one_c_date: 'Дата в 1С',
  one_c_number: 'Номер в 1С',
  one_c_registered_at: 'Регистрация в 1С',
  one_c_status: 'Статус в 1С',
  opened_at: 'Открыто',
  order_date: 'Дата заказа',
  order_no: 'Номер заказа',
  original_name: 'Имя файла',
  over_approved_at: 'Согласовано сверх договора',
  over_approved_by: 'Согласовал сверх договора',
  over_reason: 'Обоснование сверх договора',
  owner: 'Владелец',
  ownership: 'Принадлежность',
  page: 'Страница',
  page_path: 'Страница портала',
  paid_amount: 'Оплачено',
  paid_at: 'Оплачено',
  paid_on: 'Дата оплаты',
  paper: 'Бумажный экземпляр',
  params: 'Параметры',
  parent_id: 'Входит в',
  parts: 'Запчасти',
  password_hash: 'Пароль',
  path: 'Путь',
  payer: 'Плательщик',
  payload: 'Данные',
  payment_kind: 'Тип платежа',
  payment_terms: 'Порядок оплаты',
  per_hour: 'В час',
  percent: 'Процент',
  percent_complete: 'Процент выполнения',
  period: 'Период',
  period_from: 'Период с',
  period_to: 'Период по',
  permissions: 'Права',
  person_count: 'Человек',
  personnel_no: 'Табельный номер',
  phone: 'Телефон',
  place: 'Место',
  plan_end: 'Окончание по плану',
  plan_finish: 'Окончание по плану',
  plan_start: 'Начало по плану',
  planned_date: 'Плановая дата',
  plate: 'Госномер',
  points: 'Баллы',
  position: 'Должность',
  posted_at: 'Проведено',
  prefix: 'Префикс',
  prepared_by: 'Подготовил',
  prev_submitted: 'Условия прошлого раунда',
  price: 'Цена',
  price_gross: 'Цена с НДС',
  price_level: 'Уровень цен',
  price_net: 'Цена без НДС',
  price_vat: 'НДС в цене',
  price_zone: 'Ценовая зона',
  priority: 'Приоритет',
  problem: 'Проблема',
  problems: 'Проблемы',
  profession: 'Профессия',
  progress: 'Ход выполнения',
  project_id: 'Проект',
  proposal: 'Предложение',
  provider: 'Поставщик услуги',
  pto_by: 'ПТО',
  published: 'Опубликовано',
  published_at: 'Опубликовано',
  purchase_price: 'Цена закупки',
  purpose: 'Назначение платежа',
  qty: 'Количество',
  quantity: 'Количество',
  rate: 'Ставка',
  rate_pct: 'Ставка, %',
  rate_per_day: 'Ставка в день',
  rate_percent: 'Ставка, %',
  rating_comment: 'Комментарий к оценке',
  rating_score: 'Оценка',
  read_at: 'Прочитано',
  reason: 'Причина',
  reason_kind: 'Вид причины',
  receipt_no: 'Номер прихода',
  received_at: 'Получено',
  received_date: 'Дата получения',
  received_on: 'Получено',
  received_quantity: 'Получено',
  recheck: 'Повторная проверка',
  recipient: 'Получатель',
  recipient_name: 'Получатель',
  recorded_at: 'Записано',
  reference: 'Ссылка',
  reg_number: 'Регистрационный номер',
  region: 'Регион',
  registry_id: 'Реестр',
  reject_reason: 'Причина отказа',
  released_at: 'Выпущено',
  remaining_min: 'Осталось, мин',
  remark_days: 'Срок устранения, дней',
  remark_kind: 'Вид замечания',
  remark_source: 'Источник замечания',
  request_id: 'Заявка на закуп',
  request_line_id: 'Позиция заявки',
  required: 'Обязательно',
  required_date: 'Нужно к',
  resolution: 'Решение',
  resolution_note: 'Пояснение к решению',
  resolved_at: 'Закрыто',
  resolved_by: 'Закрыл',
  resolved_reason: 'Причина закрытия',
  resource_kind: 'Вид ресурса',
  resource_name: 'Ресурс',
  responded_at: 'Ответ получен',
  response_due: 'Ответить до',
  result: 'Результат',
  return_by: 'Вернуть до',
  return_comment: 'Комментарий при возврате',
  return_reason: 'Причина возврата',
  returned_at: 'Возвращено',
  returned_on: 'Возвращено',
  review_comment: 'Комментарий проверки',
  review_note: 'Примечание проверки',
  reviewed_at: 'Проверено',
  revision: 'Ревизия',
  revoke_reason: 'Причина отзыва',
  revoked_at: 'Отозвано',
  role: 'Роль',
  role_id: 'Роль',
  role_names: 'Роли',
  root_cause: 'Причина',
  round: 'Раунд согласования',
  rows: 'Строки',
  rules: 'Правила',
  sale_price: 'Цена продажи',
  scan_state: 'Проверка антивирусом',
  schedule_id: 'График',
  schedule_row_id: 'Плановый платёж договора',
  scheduled_at: 'Назначено на',
  scope: 'Область',
  scope_id: 'Объект области',
  scope_note: 'Изменение объёмов',
  scope_type: 'Область',
  score: 'Оценка',
  search: 'Поиск',
  seats: 'Мест',
  section: 'Раздел',
  section_code: 'Код раздела',
  section_id: 'Раздел',
  security_check: 'Проверка службы безопасности',
  security_memo: 'Служебная записка учредителям',
  selected_offer_id: 'Выбранное КП',
  selection_reason: 'Почему выбраны контрагент и цена',
  sent_at: 'Передано',
  sent_on: 'Отправлено',
  seq: 'Порядковый номер',
  serial_number: 'Заводской номер',
  settings: 'Настройки',
  severity: 'Важность',
  sha256: 'Отпечаток файла',
  shared: 'Общий доступ',
  shift_key: 'Смена',
  short_name: 'Краткое название',
  side: 'Сторона',
  signed_at: 'Подписано',
  signed_by: 'Подписал',
  signed_bypass: 'Подписан в обход маршрута',
  signed_date: 'Дата подписания',
  signed_on: 'Подписано',
  site_name: 'Площадка',
  size_bytes: 'Размер',
  snapshot: 'Условия версии',
  sort_order: 'Порядок',
  source: 'Источник',
  source_hash: 'Отпечаток источника',
  source_kind: 'Вид источника',
  source_note: 'Примечание к источнику',
  source_type: 'Вид источника',
  stage: 'Этап',
  stage_changed_at: 'Этап с',
  stages: 'Этапы',
  start: 'Начало',
  start_date: 'Начало',
  started_at: 'Начато',
  starts_at: 'Начало',
  starts_on: 'Начало',
  state: 'Состояние',
  state_note: 'Пояснение к состоянию',
  status: 'Статус',
  status_changed_at: 'Статус изменён',
  status_reason: 'Причина статуса',
  step: 'Пункт маршрута',
  steps: 'Шаги',
  stop_listed: 'В стоп-листе',
  stop_work: 'Остановка работ',
  storage_conditions: 'Условия хранения',
  storage_key: 'Место в хранилище',
  subcontract: 'Субподряд',
  subject: 'Предмет',
  subject_email: 'Почта человека',
  subject_name: 'Человек',
  submitted: 'Условия на согласовании',
  submitted_at: 'Подано',
  summary: 'Итог',
  supplier_id: 'Поставщик',
  suspended: 'Приостановлено',
  suspended_at: 'Приостановлено',
  suspended_reason: 'Причина приостановки',
  target_id: 'Связанная запись',
  target_type: 'Вид связанной записи',
  text: 'Текст',
  ticket: 'Обращение',
  title: 'Название',
  to_date: 'Новая дата',
  to_status: 'Статус после',
  to_warehouse_id: 'Склад-получатель',
  topic: 'Тема',
  total: 'Итого',
  total_amount: 'Итого',
  total_direct: 'Прямые затраты',
  total_equipment: 'Оборудование, итого',
  total_labor_hours: 'Трудозатраты, итого',
  total_machines: 'Машины, итого',
  total_materials: 'Материалы, итого',
  total_wages: 'Оплата труда, итого',
  totals: 'Итоги',
  type: 'Тип',
  unit: 'Единица',
  unit_direct: 'Прямые затраты на единицу',
  units: 'Единицы',
  until: 'До',
  urgency: 'Срочность',
  urgent: 'Срочно',
  user_id: 'Пользователь',
  valid_from: 'Действует с',
  valid_to: 'Действует по',
  valid_until: 'Действует до',
  valuation: 'Оценка',
  value: 'Значение',
  values: 'Суммы по месяцам',
  vat_amount: 'Сумма НДС',
  vat_rate: 'Ставка НДС',
  vat_status: 'НДС',
  verified_quantity: 'Проверенное количество',
  version: 'Версия',
  version_no: 'Номер версии',
  visible_roles: 'Видно ролям',
  visit_date: 'Дата посещения',
  wages: 'Оплата труда',
  warehouse_id: 'Склад',
  waybill: 'Путевой лист',
  waybill_number: 'Номер путевого листа',
  wear_months: 'Срок носки, мес.',
  week: 'Неделя',
  weight: 'Вес',
  work_kind: 'Вид работ',
  work_name: 'Работа',
  work_type: 'Вид работ',
  works: 'Работы',
  year: 'Год',
  zone: 'Зона',
};

/** Части имён полей */
const WORDS: Record<string, string> = {
  accept: 'приёмка',
  accepted: 'приёмка',
  account: 'счёт',
  acknowledged: 'подтверждение',
  act: 'акт',
  action: 'действие',
  activity: 'работа',
  actual: 'факт',
  address: 'адрес',
  advance: 'аванс',
  agreement: 'соглашение',
  alert: 'тревога',
  allocation: 'распределение',
  amendment: 'допсоглашение',
  amount: 'сумма',
  analog: 'аналог',
  annulled: 'аннулирование',
  answer: 'ответ',
  answered: 'ответ',
  applied: 'применение',
  approval: 'согласование',
  approved: 'утверждение',
  archive: 'архив',
  archived: 'архивирование',
  article: 'статья',
  assessed: 'оценка',
  assessment: 'оценка',
  assignee: 'исполнитель',
  attempt: 'попытка',
  attempts: 'попытки',
  author: 'автор',
  auto: 'авто',
  available: 'доступность',
  avg: 'среднее',
  balance: 'остаток',
  bank: 'банк',
  base: 'база',
  baseline: 'базовый план',
  basis: 'основание',
  batch: 'партия',
  benefit: 'выгода',
  blocked: 'блокировка',
  body: 'текст',
  budget: 'бюджет',
  buyer: 'снабженец',
  calc: 'расчёт',
  calendar: 'календарь',
  camera: 'камера',
  cancel: 'отмена',
  cancelled: 'отмена',
  card: 'карточка',
  category: 'категория',
  cert: 'сертификат',
  change: 'изменение',
  changed: 'изменение',
  changes: 'изменения',
  channel: 'канал',
  chapter: 'глава',
  check: 'проверка',
  checked: 'проверка',
  checklist: 'чек-лист',
  claim: 'претензия',
  class: 'класс',
  client: 'клиент',
  close: 'закрытие',
  closed: 'закрытие',
  code: 'код',
  codes: 'коды',
  color: 'цвет',
  comment: 'комментарий',
  committed: 'фиксация',
  company: 'компания',
  completed: 'выполнение',
  completion: 'выполнение',
  condition: 'условие',
  conditions: 'условия',
  confidence: 'уверенность',
  config: 'настройки',
  confirmed: 'подтверждение',
  construction: 'строительство',
  contract: 'договор',
  contractor: 'подрядчик',
  conv: 'пересчёт',
  copies: 'копии',
  cost: 'стоимость',
  costs: 'затраты',
  count: 'количество',
  counted: 'подсчёт',
  counterparty: 'контрагент',
  crew: 'бригада',
  crews: 'бригады',
  critical: 'критичность',
  current: 'текущее',
  customer: 'заказчик',
  daily: 'в день',
  data: 'данные',
  date: 'дата',
  day: 'день',
  days: 'дни',
  deadline: 'срок',
  decided: 'решение',
  decision: 'решение',
  decline: 'отказ',
  declined: 'отказ',
  deferral: 'отсрочка',
  delivery: 'поставка',
  delta: 'разница',
  description: 'описание',
  design: 'проект',
  designer: 'проектировщик',
  detected: 'обнаружение',
  deviation: 'отклонение',
  device: 'устройство',
  diff: 'расхождение',
  direction: 'направление',
  director: 'руководитель',
  distance: 'расстояние',
  doc: 'документ',
  docs: 'документы',
  document: 'документ',
  documents: 'документы',
  done: 'выполнено',
  downloaded: 'скачивание',
  downloads: 'скачивания',
  draft: 'черновик',
  drawings: 'чертежи',
  due: 'срок',
  duplicate: 'повтор',
  duration: 'длительность',
  effort: 'трудоёмкость',
  email: 'почта',
  end: 'окончание',
  ends: 'окончание',
  engine: 'двигатель',
  entries: 'записи',
  equipment: 'оборудование',
  error: 'ошибка',
  escalated: 'эскалация',
  estimate: 'смета',
  event: 'событие',
  exception: 'исключение',
  excess: 'превышение',
  expected: 'ожидание',
  expires: 'окончание действия',
  export: 'выгрузка',
  exported: 'выгрузка',
  ext: 'внешний',
  external: 'внешний',
  extra: 'дополнительно',
  fact: 'факт',
  field: 'поле',
  file: 'файл',
  files: 'файлы',
  financing: 'финансирование',
  findings: 'находки',
  finish: 'окончание',
  finished: 'окончание',
  first: 'первый',
  folder: 'папка',
  forecast: 'прогноз',
  foreman: 'прораб',
  from: 'с',
  fuel: 'топливо',
  group: 'группа',
  guarantee: 'гарантия',
  handed: 'передача',
  head: 'руководитель',
  held: 'проведение',
  hired: 'приём на работу',
  hold: 'остановка',
  holder: 'держатель',
  hour: 'час',
  hours: 'часы',
  idle: 'простой',
  import: 'загрузка',
  imported: 'загрузка',
  in: 'в',
  index: 'индекс',
  initiator: 'инициатор',
  inspection: 'проверка',
  installation: 'монтаж',
  instructions: 'указания',
  interval: 'интервал',
  inventory: 'инвентаризация',
  invoice: 'счёт',
  issue: 'проблема',
  issued: 'выдача',
  issuer: 'выдавший',
  item: 'позиция',
  items: 'позиции',
  k: 'коэфф.',
  key: 'ключ',
  kind: 'вид',
  km: 'км',
  labor: 'труд',
  lag: 'задержка',
  languages: 'языки',
  last: 'последний',
  lease: 'аренда',
  letter: 'письмо',
  level: 'уровень',
  limit: 'лимит',
  line: 'строка',
  lines: 'строки',
  link: 'связь',
  linked: 'связь',
  list: 'список',
  litres: 'литры',
  location: 'место',
  locked: 'блокировка',
  lodging: 'проживание',
  machine: 'машина',
  machines: 'машины',
  machinist: 'машинист',
  manager: 'руководитель',
  mark: 'марка',
  match: 'сверка',
  matched: 'сверка',
  materials: 'материалы',
  max: 'наибольшее',
  meals: 'питание',
  measure: 'мера',
  measures: 'меры',
  mechanic: 'механик',
  merged: 'объединение',
  message: 'сообщение',
  meter: 'счётчик',
  method: 'способ',
  min: 'наименьшее',
  miss: 'пропуск',
  missing: 'нет в наличии',
  mode: 'режим',
  model: 'модель',
  month: 'месяц',
  monthly: 'в месяц',
  months: 'месяцы',
  name: 'название',
  need: 'потребность',
  needs: 'нужно',
  next: 'следующий',
  no: 'номер',
  nomination: 'номинация',
  norm: 'норма',
  note: 'примечание',
  notes: 'примечания',
  number: 'номер',
  object: 'объект',
  observation: 'наблюдение',
  occurred: 'событие',
  odo: 'одометр',
  odometer: 'пробег',
  offer: 'КП',
  offline: 'без связи',
  offset: 'зачёт',
  online: 'на связи',
  opened: 'открытие',
  operator: 'оператор',
  order: 'заказ',
  organization: 'организация',
  origin: 'происхождение',
  other: 'прочее',
  overhead: 'накладные',
  owner: 'владелец',
  package: 'пакет',
  page: 'страница',
  pages: 'страницы',
  paid: 'оплата',
  param: 'параметр',
  params: 'параметры',
  part: 'часть',
  parts: 'запчасти',
  passport: 'паспорт',
  path: 'путь',
  pay: 'оплата',
  payment: 'платёж',
  payroll: 'фонд оплаты',
  pct: '%',
  pending: 'ожидание',
  per: 'на',
  percent: 'процент',
  period: 'период',
  person: 'человек',
  personnel: 'табельный',
  photo: 'фото',
  place: 'место',
  places: 'места',
  plan: 'план',
  planned: 'план',
  points: 'баллы',
  policy: 'правило',
  portal: 'портал',
  posted: 'проведение',
  ppe: 'СИЗ',
  prepared: 'подготовка',
  price: 'цена',
  prices: 'цены',
  problem: 'проблема',
  profession: 'профессия',
  profile: 'профиль',
  project: 'проект',
  protocol: 'протокол',
  published: 'публикация',
  purchase: 'закупка',
  qc: 'входной контроль',
  qty: 'количество',
  quantity: 'количество',
  rate: 'ставка',
  rated: 'оценка',
  rating: 'оценка',
  read: 'прочтение',
  reason: 'причина',
  receipt: 'приход',
  received: 'получение',
  recipient: 'получатель',
  recorded: 'запись',
  ref: 'ссылка',
  reference: 'ссылка',
  region: 'регион',
  release: 'выпуск',
  released: 'выпуск',
  remaining: 'остаток',
  remark: 'замечание',
  reminded: 'напоминание',
  reminder: 'напоминание',
  rent: 'аренда',
  replace: 'замена',
  replaced: 'замена',
  reply: 'ответ',
  report: 'отчёт',
  request: 'заявка',
  requested: 'запрос',
  required: 'обязательно',
  reservation: 'резерв',
  resolution: 'решение',
  resolved: 'решение',
  resource: 'ресурс',
  responded: 'ответ',
  response: 'ответ',
  responsible: 'ответственный',
  result: 'результат',
  return: 'возврат',
  returned: 'возврат',
  revenue: 'выручка',
  review: 'проверка',
  reviewed: 'проверка',
  revision: 'ревизия',
  revoked: 'отзыв',
  role: 'роль',
  roles: 'роли',
  root: 'корень',
  route: 'маршрут',
  rows: 'строки',
  rule: 'правило',
  rules: 'правила',
  run: 'запуск',
  sale: 'продажа',
  sample: 'проба',
  scan: 'проверка антивирусом',
  scanned: 'проверка антивирусом',
  schedule: 'график',
  scheduled: 'назначение',
  score: 'оценка',
  section: 'раздел',
  sent: 'отправка',
  serial: 'заводской',
  service: 'обслуживание',
  set: 'комплект',
  sheet: 'лист',
  shift: 'смена',
  sign: 'подпись',
  signed: 'подпись',
  site: 'площадка',
  size: 'размер',
  source: 'источник',
  stage: 'этап',
  staff: 'сотрудники',
  stamp: 'штамп',
  stamped: 'штамп',
  start: 'начало',
  started: 'начало',
  starts: 'начало',
  state: 'состояние',
  status: 'статус',
  step: 'шаг',
  steps: 'шаги',
  stock: 'остаток',
  stop: 'остановка',
  storage: 'хранение',
  subject: 'предмет',
  submitted: 'подача',
  success: 'успех',
  summary: 'итог',
  supplier: 'поставщик',
  support: 'поддержка',
  suspended: 'приостановка',
  target: 'цель',
  task: 'поручение',
  template: 'шаблон',
  tender: 'тендер',
  terms: 'условия',
  text: 'текст',
  ticket: 'обращение',
  title: 'название',
  to: 'по',
  tolerance: 'допуск',
  total: 'итого',
  totals: 'итоги',
  tour: 'экскурсия',
  travel: 'проезд',
  trip: 'поездка',
  type: 'тип',
  undo: 'отмена',
  undone: 'отмена',
  unit: 'единица',
  units: 'единицы',
  until: 'до',
  urgent: 'срочно',
  usage: 'использование',
  used: 'использование',
  user: 'сотрудник',
  users: 'сотрудники',
  valid: 'действие',
  valuation: 'оценка',
  value: 'значение',
  vat: 'НДС',
  verified: 'проверено',
  version: 'версия',
  visible: 'видимость',
  visit: 'посещение',
  volume: 'объём',
  volumes: 'объёмы',
  wage: 'оплата труда',
  wages: 'оплата труда',
  warehouse: 'склад',
  waybill: 'путевой лист',
  week: 'неделя',
  weight: 'вес',
  weights: 'веса',
  withdrawn: 'отзыв',
  withheld: 'удержание',
  work: 'работа',
  worker: 'работник',
  works: 'работы',
  year: 'год',
  zone: 'зона',
};

/** Хвост имени поля — уточнение в скобках: «answered_at» — «Ответ (время)» */
const TAIL: Record<string, string> = {
  at: 'время',
  on: 'дата',
  date: 'дата',
  by: 'кто',
  note: 'примечание',
  notes: 'примечания',
  reason: 'причина',
  comment: 'комментарий',
  count: 'количество',
  ids: 'список',
};

/** Хвост — единица измерения: «delivery_days» — «Поставка, дней» */
const UNIT_TAIL: Record<string, string> = {
  pct: '%',
  percent: '%',
  days: 'дней',
  hours: 'ч',
  min: 'мин',
  km: 'км',
  months: 'мес.',
};

/** Начало имени поля — уточнение в скобках: «plan_start» — «Начало (план)» */
const HEAD: Record<string, string> = {
  plan: 'план',
  planned: 'план',
  actual: 'факт',
  fact: 'факт',
  last: 'последнее',
  next: 'следующее',
  total: 'итого',
  max: 'наибольшее',
  min: 'наименьшее',
  old: 'прежнее',
  new: 'новое',
  prev: 'прежнее',
};

/** Название поля из частей имени, если его нет в словаре */
export function humanizeField(field: string): string {
  let parts = field.split('_').filter(Boolean);
  if (!parts.length) return field;
  const notes: string[] = [];
  let unit: string | null = null;
  if (parts.length > 1 && (parts[0] === 'is' || parts[0] === 'has')) parts = parts.slice(1);
  if (parts.length > 1 && parts[parts.length - 1] === 'id') parts = parts.slice(0, -1);
  const tail = parts[parts.length - 1]!;
  if (parts.length > 1 && TAIL[tail]) {
    notes.push(TAIL[tail]);
    parts = parts.slice(0, -1);
  } else if (parts.length > 1 && UNIT_TAIL[tail]) {
    unit = UNIT_TAIL[tail];
    parts = parts.slice(0, -1);
  }
  const head = parts[0]!;
  if (parts.length > 1 && HEAD[head]) {
    notes.unshift(HEAD[head]);
    parts = parts.slice(1);
  }
  const text = parts.map((p) => WORDS[p] ?? p).join(' ');
  const out = `${text}${unit ? `, ${unit}` : ''}${notes.length ? ` (${notes.join(', ')})` : ''}`;
  return out.charAt(0).toUpperCase() + out.slice(1);
}

/** Подпись поля: словарь, название связанной записи (по внешнему ключу), части имени */
export function journalFieldTitle(field: string, refTitle?: string | null): string {
  return JOURNAL_FIELD_TITLES[field] ?? refTitle ?? humanizeField(field);
}
